import * as React from "react";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { decodeHTMLEntities, gtmPush } from "../../../../../helpers";
import { CMSState, Url } from "../../../../cms/blocks/types.gen";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { PublicSite_CustomPageData } from "../../../application.mod";

export type LinkBlockProps = {
  index: number
  title: string
  intro?: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  items: LinkProps[]
  useSVGIcons: boolean
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type LinkProps = {
  key?: string
  title: string
  url: Url
  text?: string
  is_link_external: boolean
  target?: "_blank" | "_self"
}

export function LinkBlock<customBlockData, extra_images> (
  props: LinkBlockProps,
  options?: {
    key?: string
  }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData> , Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData> ) =>
    mk_widget({
      run: _ => (
        <section id={`io-${options && options.key ? options.key : props.index}`}
          className="block block--linklist block--lists"
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className="block__inner container container--m gutter--m spacing--m">
            {(props.title || (props.intro && props.intro !== '<p></p>')) && (
              <header className="block__header block__header--spacing block__header--columns">
                {props.title && <h2 className="block__title typo--l ff--primary ls-second-item">{decodeHTMLEntities(props.title)}</h2>}
                {(props.intro && props.intro !== '<p></p>') && <div className="block__intro ls-first-item" dangerouslySetInnerHTML={{ __html: props.intro }}></div>}
              </header>
            )}

            <div className="block__content">
              <ul className="block__list">
                {props.items.map((l, index) => (
                  l.title && l.url && (
                    <li className="block__item item ls-item">
                      {link(linkWrapper({title:l.title, url:l.url}),
                        {
                          classname: 'item__link border-radius--s'
                        },
                        (<>
                          <span className="item__text typo--ml ff--primary">{l.title}</span>
                          <svg className="item__icon" height="14" width="16" aria-hidden="true"><use xlinkHref="#arrow"/></svg>
                        </>), 
                        () => {
                          gtmPush({
                            event: 'link_list', 
                            link_list_click: 'yes', 
                            click_text: l.title
                          })
                        }
                      )}
                    </li>
                  )
                ))}
              </ul>
            </div>
            
            {(props.primary_button || props.secondary_button) && (
              <footer className="block__footer ls-clickables">
                {props.primary_button && (
                    link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                      { classname: 'button button--primary ls-clickable' },
                      props.primary_button.text, 
                      () => {
                        gtmPush({
                          event: 'link_list', 
                          link_list_click: 'no', 
                          cta_type: 'primary_button', 
                          click_text: props.primary_button.text
                        })
                      }
                    )
                )}
                {props.secondary_button && (
                    link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      { classname: 'button button--secondary ls-clickable' },
                      props.secondary_button.text, 
                      () => {
                        gtmPush({
                          event: 'link_list', 
                          link_list_click: 'no', 
                          cta_type: 'secondary_button', 
                          click_text: props.secondary_button.text
                        })
                      }
                    )
                )}
              </footer>
            )}
          </div>
        </section>
      ),
    })
}
